import React, { useState } from 'react';
import { FiMaximize2, FiMinimize2 } from 'react-icons/fi';
import Grow from '@material-ui/core/Grow';

import { Container, Content, Box } from './style';

export default function BoxTip({ children }) {
  const [open, setOpen] = useState(false);

  function toggle() {
    setOpen((value) => !value);
  }
  return (
    <Box>
      <button onClick={toggle}>
        <FiMaximize2 />
        {'  '}{' '}
        <u>
          <i>Ver dica</i>
        </u>
      </button>
      <Grow in={open}>
        <Container>
          <button onClick={toggle}>
            <FiMinimize2 />
          </button>
          <Content>{children}</Content>
        </Container>
      </Grow>
    </Box>
  );
}
